import {
  Button,
  Input,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import Select from "react-select";
import useBasic from "./useBasic";
import Style from "../../../../CMS/CustomNotification/customNotification.module.scss";

const Basic = ({ formik, getFieldError,basicData, storeState, setStoreState }) => {
  const {
    isImageUploading,
    handleTypeChange,
    getMinEndDate,
    getMaxDate,
    handleNext,
    handleCloseModal,
    handleRemoveSelectedEmail,
  } = useBasic({ formik,basicData, storeState, setStoreState });
  return (
    <div className="row">
      <Input
        label={"Season Name"}
        type="text"
        id="season_name"
        name="season_name"
        className={`pro-input lg ${getFieldError("season_name") && " error"}`}
        {...formik.getFieldProps("season_name")}
        error={getFieldError("season_name")}
        errorMessage={getFieldError("season_name")}
      />
      <Input
        label={"From Date"}
        type="date"
        id="start_date"
        name="start_date"
        className={`pro-input lg ${getFieldError("start_date") && " error"}`}
        {...formik.getFieldProps("start_date")}
        min={new Date().toISOString().split("T")[0]}
        max={getMaxDate()}
        error={getFieldError("start_date")}
        errorMessage={getFieldError("start_date")}
      />
      <Input
        label={"To Date"}
        type="date"
        id="end_date"
        name="end_date"
        className={`pro-input lg ${getFieldError("end_date") && " error"}`}
        {...formik.getFieldProps("end_date")}
        min={getMinEndDate()}
        disabled={formik?.values?.start_date === ""}
        error={getFieldError("end_date")}
        errorMessage={getFieldError("end_date")}
      />
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Store
        </label>
        <Select
          id="store"
          name="store"
          placeholder={"Select"}
          className={`pro-input lg  ${getFieldError("store") && " error"}`}
          classNamePrefix="pro-input"
          options={basicData?.data?.store ?? []}
          value={
            basicData?.data?.store?.filter((item) =>
              formik?.values?.store?.includes(item),
            ) || []
          }
          getOptionLabel={(option) => option?.name}
          getOptionValue={(option) => option?._id}
          onBlur={formik.handleBlur("store")}
          onChange={(e) => handleTypeChange(e)}
          menuPlacement="auto"
          isMulti={true}
        />
        {getFieldError("store") && (
          <span className="error-text">{getFieldError("store")}</span>
        )}
      </div>

      <div className={`${Style.number_badge_wrap} pro-mb-4`}>
        {formik?.values?.selected_emails?.map((item, index) => (
          <div key={index} className={Style.badge}>
            {item}
            <span
              onClick={() => handleRemoveSelectedEmail(index)}
              className="material-symbols-outlined"
            >
              close
            </span>
          </div>
        ))}
      </div>
      {formik?.errors?.selected_emails &&
        formik?.values?.selected_emails?.length <= 0 && (
          <span className="error-text error error-img">
            {getFieldError("selected_emails")}
          </span>
        )}

      <div className="pro-check-box pro-py-2">
        <div className="form-check form-switch ">
          <input
            className="form-check-input cursor-pointer"
            type="checkbox"
            role="switch"
            id="flexSwitchCheckDefault"
            checked={Boolean(formik.values?.status === 1) ?? false}
            onChange={(e) =>
              formik.setFieldValue(`status`, e?.target?.checked ? 1 : 2)
            }
          />
          <label htmlFor="default" className="pro-check-label">
            Status
          </label>
        </div>
      </div>
      <div className={`col-12 pro-d-flex pro-justify-end pro-mt-auto pro-pb-5`}>
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleCloseModal}
          type="button"
        >
          Cancel
        </Button>

        <Button
          className={"pro-btn-primary lg pro-ms-3"}
          type="button"
          onClick={handleNext}
          disabled={isImageUploading}
        >
          {"Next"}
        </Button>
      </div>
    </div>
  );
};

export default Basic;
